"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doesEventAOverlapWithEventB = void 0;
const doesEventAOverlapWithEventB = (eventA, eventB) => {
    // Check if A starts after B ends or ends before B starts
    if (eventA.dateFrom >= eventB.dateTo || eventA.dateTo <= eventB.dateFrom) {
        return false;
    }
    return true;
};
exports.doesEventAOverlapWithEventB = doesEventAOverlapWithEventB;
//# sourceMappingURL=index.js.map